import { sources } from '../data/sources';
import { ExternalIcon } from './Icons';

export function SourceList({ ids, compact = false }: { ids: string[]; compact?: boolean }) {
  const items = ids.map((id) => sources.find((source) => source.id === id)).filter((source) => source !== undefined);
  if (items.length === 0) return null;

  return (
    <ul className={compact ? 'source-list is-compact' : 'source-list'}>
      {items.map((source) => (
        <li key={source.id}>
          <a href={source.url} target="_blank" rel="noreferrer">
            <span className="source-title">{source.title}</span>
            <span className="source-meta">
              {source.publisher} · {source.year}
              <ExternalIcon size={12} />
            </span>
          </a>
          {!compact && source.note ? <p className="source-note">{source.note}</p> : null}
        </li>
      ))}
    </ul>
  );
}
